module.exports = __webpack_public_path__ + "static/media/app-store-promotion-code.fdd474c6.jpg";